var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-button',{staticClass:"close-btn",on:{"clickHandler":function($event){return _vm.$emit('clickHandler')}}},[_c('i',{staticClass:"icon-close-btn"})])
}
var staticRenderFns = []

export { render, staticRenderFns }